import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import * as Yup from 'yup';

import { Slug } from '@fnv-core/utils';
import { FormControlWithFormsProps } from '../interfaces/FormControlProps';
import { FormFieldStateHelpers } from './helpers/FormFieldStateHelpers';
import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { LabelAndPopover } from './components/label-and-popover';
import { IEmailAddressListFieldDefinition } from '../interfaces/Fields';

export interface InputState {
    dataSourceCounter: number;
    timer: any;
    emailValue: string;
    emailError: string;
    showAllEmailAddresses: boolean;
    showAllExistingEmailAddresses: boolean;
    isLoading: boolean;
}

export class EmailAddressList extends React.Component<FormControlWithFormsProps, InputState> {
    constructor(props: FormControlWithFormsProps) {
        super(props);
        this.state = {
            dataSourceCounter: 0,
            timer: undefined,
            emailValue: "",
            emailError: "",
            showAllEmailAddresses: false,
            showAllExistingEmailAddresses: false,
            isLoading: false
        };
    }

    private get _emailAddressListFieldDefinition(): IEmailAddressListFieldDefinition {
      return this.props.formFieldDefinition as IEmailAddressListFieldDefinition;
    }

    onKeyDown = (e) => {
        if (e.key === 'Enter') {
          this.addEmail(e);
        }
      }

    onChange = (e) => {
        e.preventDefault();
        FormFieldStateHelpers.clearMarkedFields(this);
        this.setState({emailValue: e.target.value});
        return false;
    }
    onBlur = (e) => {
        //
    }
    onFocus = (e) => {
        // No action defined
    }

    addEmail = (e) => {
        e.preventDefault();
        if ((this.state.emailValue || "").trim() === "") {
            this.setState({emailError : ""});
            return;
        }

        let list = this.state.emailValue.split(/[\s,;]+/);

        // remove < > because copy and pasting from outlook should be possible
        // that format is abc <def@email.nl>
        // and to be sure .. also remove all quotes

        list = list.map((email) => {
          return (email || "").replace(/[<>"']/g, '');
        });

        // validate all email adresses
        let validatorPromises : any[] = [];
        list.map((email) => {
            let schemaValidator = Yup.string().email(this._emailAddressListFieldDefinition.emailError);        
            validatorPromises.push(schemaValidator.isValid(email));
        });

        Promise.all(validatorPromises).then((result : any[]) => {
            let hasError = false;
            if (result.length > 0) {
                hasError = !result[0];
            }
            result.map((validatorResult) => {
                hasError = hasError && !validatorResult;
            });

            // if all email addresses are not valid.. then show error
            if (!!hasError) {
                this.setState({emailError: this._emailAddressListFieldDefinition.emailError});
                return;
            }

            let emailAdresses: string[] = (this.props.field.value as string || '').split(this._emailAddressListFieldDefinition.emailSeparator);
            
            emailAdresses = emailAdresses.filter((email) => {
                return email && email !== '';
            });

            list.map((copyAndPastedEmail, index) => {

                // add only valid email adresses
                if (result[index] && copyAndPastedEmail && copyAndPastedEmail !== '') {
                    const filterEmail = emailAdresses.filter((email, index) => {
                        return email === copyAndPastedEmail;
                    });
                    if (filterEmail.length === 0) {
                        emailAdresses.push(copyAndPastedEmail);
                    }
                }
            });

            this.setState({ emailValue: '', emailError: '' }, () => {
                FormFieldStateHelpers.updateFormikField(this as any, emailAdresses.join(this._emailAddressListFieldDefinition.emailSeparator));
            });
        }).catch(() => {
            this.setState({ emailError: this._emailAddressListFieldDefinition.emailError });
        });
        
        return false;
    }

    deleteEmailFromList = (emailToDelete, event) => {
        event.preventDefault();
        let emailAdresses: string[] = (this.props.field.value || '').split(this._emailAddressListFieldDefinition.emailSeparator);
        const filterEmail = emailAdresses.filter((email, index) => {
            return email !== emailToDelete;
        });
        FormFieldStateHelpers.updateFormikField(this as any, filterEmail.join(this._emailAddressListFieldDefinition.emailSeparator));
        return false;
    }

    showAllOtherExistingEmailAddresses = (event) => {
        event.preventDefault();
        this.setState((state) => {
            return {
                ...state,
                showAllExistingEmailAddresses : !state.showAllExistingEmailAddresses
            };
        });
        return false;
    }

    getExistingEmailAddressesList = () => {
        const fieldForExistingEmailAddresses = this._emailAddressListFieldDefinition.fieldForExistingEmailAddresses;
        if (fieldForExistingEmailAddresses) {
            const emailSeparator = this._emailAddressListFieldDefinition.emailSeparator;
            let emailAdresses: string[] = (this.props.formikBag.values[fieldForExistingEmailAddresses] as string || '').split(emailSeparator);

            if (!!this._emailAddressListFieldDefinition.isSummary) {
                const emailAddressesString = this.props.forms[this._emailAddressListFieldDefinition.form][fieldForExistingEmailAddresses] as string || '';
                emailAdresses = emailAddressesString.split(emailSeparator);
            }
            emailAdresses = emailAdresses.filter(email => email !== "");
            const emailCount = emailAdresses.length;

            return <div className="EmailAddressList__list EmailAddressList__list-readonly">
                <label className="d-block">{this._emailAddressListFieldDefinition.existingEmailAddressesLabel || "Personen die al uitgenodigd zijn"}</label>
                {emailAdresses.map((email, index) => {

                if (emailCount >= 6 && index >= 4 && !this.state.showAllExistingEmailAddresses) {
                    return <React.Fragment key={"email" + index}></React.Fragment>;
                }
                return <div  key={"email" + index} className="EmailAddressList__email-item EmailAddressList__email-item-readonly">
                        <span className="icon icon-user"></span>
                        <span className="EmailAddressList__email">{email}</span>                        
                    </div>;
            })}{(emailCount > 5 && !this.state.showAllExistingEmailAddresses) && 
                <a className="EmailAddressList__list-show-all" href="#" onClick={this.showAllOtherExistingEmailAddresses}>{emailCount - 4} anderen</a>}    
            </div>;
        }
        return <></>;
    }

    showAllOtherEmailAddresses = (event) => {
        event.preventDefault();
        this.setState((state) => {
            return {
                ...state,
                showAllEmailAddresses : !state.showAllEmailAddresses
            };
        });
        return false;
    }

    getEmailList = () => {
        const isSummary = this._emailAddressListFieldDefinition.isSummary;
        const emailSeparator = this._emailAddressListFieldDefinition.emailSeparator;

        let emailAdresses: string[] = (this.props.field.value || '').split(emailSeparator);
        if (!!isSummary) {
            emailAdresses = (this.props.forms[this._emailAddressListFieldDefinition.form][this._emailAddressListFieldDefinition.name] as string || '').split(emailSeparator);
        }
        emailAdresses = emailAdresses.filter(email => !!email);
        const emailCount = emailAdresses.length;

        return <div className="EmailAddressList__list">{emailAdresses.map((email, index) => {            
            if (emailCount >= 6 && index >= 4 && !this.state.showAllEmailAddresses) {
                return <React.Fragment key={"email" + index}></React.Fragment>;
            }
            return <div  key={"email" + index} className="EmailAddressList__email-item">
                    <span className="icon icon-user"></span>
                    <span className="EmailAddressList__email">{email}</span>
                    {!isSummary && <a onClick={this.deleteEmailFromList.bind(
                        this,
                        email
                    )} href="#"><span className="icon icon-cross"></span></a>}
                </div>;
        })}{(emailCount > 5 && !this.state.showAllEmailAddresses) && 
            <a className="EmailAddressList__list-show-all" onClick={this.showAllOtherEmailAddresses} href="#">{emailCount - 4} anderen</a>}
        </div>;
    }

    render() {
        const inputProperties = {
            // Input properties has everything needed to deal with manual input
            // It will load related data when a datasource is set
            ...FormControlHelpers.inputProperties(this),
            onChange : this.onChange,
            onBlur : this.onBlur,
            onFocus: this.onFocus,
            onKeyDown: this.onKeyDown,
            value: this.state.emailValue
        };

        return (
            <>
            <div className={FormStylingHelpers.getFormGroupStyle(this.props) + 
                ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + "-input-form-group" + 
                (!!this.props.formFieldDefinition.isSummary && " EmailAddressList__summary")}>
                <LabelAndPopover 
                    fieldId={PropertyHelpers.getFieldID(this.props)} 
                    label={FormLabelHelpers.getFieldLabel(this)}
                    explanation={this.props.formFieldDefinition.explanation}
                    hasPopover={this.props.formFieldDefinition.hasPopover}                    
                ></LabelAndPopover>
                <div className="input-group EmailAddressList__input-group">
                    {!this.props.formFieldDefinition.readOnly && <>
                        <input
                            {...inputProperties}
                            type="text"
                            className={FormStylingHelpers.getInputStyle(this)}
                        />                    
                        <a href="#" className="EmailAddressList__add btn btn-primary" onClick={this.addEmail}>Toevoegen</a>
                    </>}
                    {!this.props.formFieldDefinition.readOnly && FormControlHelpers.invalidFeedbackComponent(this)}
                    {!this.props.formFieldDefinition.readOnly && this.state.emailError !== "" ? <div className="form__invalid-feedback EmailAddressList__error">
                        {ReactHtmlParser(this.state.emailError)}
                    </div> : null}
                </div>
                {this.props.formFieldDefinition.hasPopover === undefined && 
                 this.props.formFieldDefinition.explanation && 
                    this.props.formFieldDefinition.explanation !== "" ? <span className="form-control-plaintext-explanation">{ReactHtmlParser(this.props.formFieldDefinition.explanation)}</span> : null}
                {this.getEmailList()}
                {this.getExistingEmailAddressesList()}
            </div>
            <div className={ Slug.fromString(this.props.formFieldDefinition.name) + "-input-form-group-after form-group-after"}></div>
            </>
        );
    }
}
